@if(miscDocument){
<div class="row">
<div class="col-md-6">
  <div>
    <div class="card shadow-sm ">
      <div class="card-header with-border">
        Misc-Document
      </div>
      <div class="card-body">
        <div>
          <form #commentForm="ngForm"
            class="form-horizontal"
            (ngSubmit)="saveMiscDocument()">
            <div class="form-group row">
                <app-material-auto-complete
                  id="selectedMiscDocumentType"
                  [placeholder]="'Type'"
                  [items]="documentTypes"
                  name="selectedMiscDocumentType"
                  [(ngModel)]="miscDocument.miscDocumentType"
                  [formatter]="miscDocumentTypeFormatter"
                  [required]="true">
                </app-material-auto-complete>
            </div>
            <div class="form-group row">
              <app-material-chunk-file-uploader
                  [accept]="'.pdf'"
                  name="document"
                  [ngModel]="doc"
                  (ngModelChange)="uploadDocument($event)">
              </app-material-chunk-file-uploader>
            </div>
            <div class="form-group row">
              <mat-form-field class="col-md-12" appearance="outline">
                <mat-label>Comment</mat-label>
                <textarea
                  matInput
                  id="comment"
                  name="comment"
                  cols="40" rows="5"
                  [(ngModel)]="miscDocument.comment"
                  required>
                </textarea>
              </mat-form-field>
            </div>
            <div class="btn-group pull-right mt-2">
              <app-material-pg-button
                id="cancel"
                class="me-1"
                (clicked)="backToVoyage()"
                label="Back to voyage">
              </app-material-pg-button>
              <app-material-pg-button
                id="submit"
                class="me-1"
                (clicked)="saveMiscDocument()"
                [disabled]="!commentForm.form.valid"
                label="Save">
              </app-material-pg-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="col-md-6">
  <div>
    <app-material-pdf-viewer [fileId]="miscDocument.fileId"> </app-material-pdf-viewer>
  </div>
</div>
</div>
}
